import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'

import { Logic, Operator } from 'core-components/types'

import { getVersionCrud } from './getVersionCrud'

export const getVersionByVersionUID = async (versionUID: string): Promise<IELTData | null> => {
  const crud = getVersionCrud('getVersionByVersionId')
  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'UID',
        value: versionUID,
        operator: Operator.EQUAL,
      },
    ],
  })
  const res = await crud.fetch()
  return res?.items[0] || null
}
